import * as c from '../_generated/Colors';
export const lightPalette = {
    type: 'light',
    semantic: {
        colorBackground: c.ColorBackgroundLight,
        colorBackgroundSecondary: c.ColorBackgroundSecondaryLight,
        colorBackgroundInverse: c.ColorBackgroundInverseLight,
        colorBackgroundGray: c.ColorBackgroundGrayLight,
        colorBackgroundDisabled: c.ColorBackgroundDisabledLight,
        colorBackgroundHighlight: c.ColorBackgroundHighlightLight,
        colorBackgroundRaised: c.ColorBackgroundRaisedLight,
        colorBackgroundEdit: c.ColorBackgroundEditLight,
        colorBackgroundGrayEmp: c.ColorBackgroundGrayEmpLight,
        colorHover: c.ColorHoverLight,
        colorCurtain: c.ColorCurtainLight,
        colorBorder: c.ColorBorderLight,
        colorBorderDisabled: c.ColorBorderDisabledLight,
        colorBorderGrid: c.ColorBorderGridLight,
        colorBorderDeEmp: c.ColorBorderDeEmpLight,
        colorSelection: c.ColorSelectionLight,
        colorLogo: c.ColorLogoLight,
        colorForeground: c.ColorForegroundLight,
        colorForegroundLight: c.ColorForegroundLightLight,
        colorForegroundEmp: c.ColorForegroundEmpLight,
        colorForegroundDeEmp: c.ColorForegroundDeEmpLight,
        colorForegroundDisable: c.ColorForegroundDisableLight,
        colorForegroundInverse: c.ColorForegroundInverseLight,
        colorForegroundHighlight: c.ColorForegroundHighlightLight,
        colorForegroundHighlightSelected: c.ColorForegroundHighlightSelectedLight,
        colorForegroundHighlightSelectedHover: c.ColorForegroundHighlightSelectedHoverLight,
        colorForegroundLink: c.ColorForegroundLinkLight,
        colorForegroundLinkPressed: c.ColorForegroundLinkPressedLight,
        colorForegroundInvDeEmp: c.ColorForegroundInvDeEmpLight,
        colorPrimary: c.ColorPrimaryLight,
        colorPrimaryLighter: c.ColorPrimaryLighterLight,
        colorPrimaryDarker: c.ColorPrimaryDarkerLight,
        colorPrimaryHover: c.ColorPrimaryHoverLight,
        colorPrimaryFocused: c.ColorPrimaryFocusedLight,
        colorPrimaryPressed: c.ColorPrimaryPressedLight,
        colorSecondaryFocused: c.ColorSecondaryFocusedLight,
        colorSecondaryPressed: c.ColorSecondaryPressedLight,
        colorChipDefaultBackground: c.ColorChipDefaultBackgroundLight,
        colorChipErrorBackground: c.ColorChipErrorBackgroundLight,
        colorChipWarningBackground: c.ColorChipWarningBackgroundLight,
        colorChipInfoBackground: c.ColorChipInfoBackgroundLight,
        colorChipSuccessBackground: c.ColorChipSuccessBackgroundLight,
        colorErrorIcon: c.ColorErrorIconLight,
        colorErrorText: c.ColorErrorTextLight,
        colorErrorBackground: c.ColorErrorBackgroundLight,
        colorErrorForegroundInverse: c.ColorErrorForegroundInverseLight,
        colorInfoForeground: c.ColorInfoForegroundLight,
        colorInfoIcon: c.ColorInfoIconLight,
        colorInfoText: c.ColorInfoTextLight,
        colorInfoForegroundInverse: c.ColorInfoForegroundInverseLight,
        colorInfoBackground: c.ColorInfoBackgroundLight,
        colorSuccessIcon: c.ColorSuccessIconLight,
        colorSuccessText: c.ColorSuccessTextLight,
        colorSuccessBackground: c.ColorSuccessBackgroundLight,
        colorSuccessForegroundInverse: c.ColorSuccessForegroundInverseLight,
        colorWarningIcon: c.ColorWarningIconLight,
        colorWarningText: c.ColorWarningTextLight,
        colorWarningBackground: c.ColorWarningBackgroundLight,
        colorWarningForegroundInverse: c.ColorWarningForegroundInverseLight,
        colorIconDefault: c.ColorIconDefaultLight,
        colorIconInvertedDefault: c.ColorIconInvertedDefaultLight,
        colorToggleOffHover: c.ColorToggleOffHoverLight,
        colorToggleOffFocus: c.ColorToggleOffFocusLight,
        colorToggleOffPressed: c.ColorToggleOffPressedLight,
        colorToggleOnHover: c.ColorToggleOnHoverLight,
        colorToggleOnFocus: c.ColorToggleOnFocusLight,
        colorToggleOnPressed: c.ColorToggleOnPressedLight,
        colorCalloutBackground: c.ColorCalloutBackgroundLight,
        colorWarn: c.ColorWarnLight,
        colorWarnDarker: c.ColorWarnDarkerLight,
        colorWarnHover: c.ColorWarnHoverLight,
        colorWarnFocus: c.ColorWarnFocusLight,
        colorWarnPressed: c.ColorWarnPressedLight,
        colorCarouselBackground: c.ColorCarouselBackgroundLight,
        colorIconButtonHover: c.ColorIconButtonHoverLight,
        colorIconButtonFocus: c.ColorIconButtonFocusLight,
        colorIconButtonPressed: c.ColorIconButtonPressedLight,
        colorCodeFunction: c.ColorCodeFunctionLight,
        colorCodeOperator: c.ColorCodeOperatorLight,
        colorCodeNumeric: c.ColorCodeNumericLight,
        colorCodeText: c.ColorCodeTextLight,
        colorToggleThumbOff: c.ColorToggleThumbOffLight,
        colorToggleTrackOff: c.ColorToggleTrackOffLight,
        colorToggleThumbOn: c.ColorToggleThumbOnLight,
        colorToggleTrackOn: c.ColorToggleTrackOnLight,
        colorToggleThumbOffDisabled: c.ColorToggleThumbOffDisabledLight,
        colorToggleTrackOffDisabled: c.ColorToggleTrackOffDisabledLight,
        colorToggleThumbOnDisabled: c.ColorToggleThumbOnDisabledLight,
        colorToggleTrackOnDisabled: c.ColorToggleTrackOnDisabledLight,
        // Keep these typos for compatibility reasons
        colorBackgroundHigh: c.ColorBackgroundHighlightLight,
        colorForegroundHigh: c.ColorForegroundHighlightLight,
        colorForegroundHighSelected: c.ColorForegroundHighlightSelectedLight,
        colorForegroundHighSelectedHover: c.ColorForegroundHighlightSelectedHoverLight,
    },
    primary: {
        contrastText: c.ColorWhite,
        light: c.ColorPrimaryLighterLight,
        main: c.ColorPrimaryLight,
        dark: c.ColorPrimaryLighterDark,
    },
    secondary: {
        contrastText: c.ColorWhite,
        light: c.ColorPrimaryLighterLight,
        main: c.ColorPrimaryLight,
        dark: c.ColorPrimaryLighterDark,
    },
    error: {
        contrastText: c.ColorWhite,
        light: c.ColorError250,
        main: c.ColorError500,
        dark: c.ColorError750,
    },
    success: {
        contrastText: c.ColorWhite,
        light: c.ColorGreen250,
        main: c.ColorGreen500,
        dark: c.ColorGreen750,
    },
    warning: {
        contrastText: c.ColorWhite,
        light: c.ColorWarning300,
        main: c.ColorWarning500,
        dark: c.ColorWarning700,
    },
    info: {
        contrastText: c.ColorBlack,
        light: c.ColorInfoBackgroundLight,
        main: c.ColorInfoForegroundLight,
        dark: c.ColorInfo700,
    },
    orange: {
        100: c.ColorOrange100,
        200: c.ColorOrange200,
        300: c.ColorOrange300,
        400: c.ColorOrange400,
        500: c.ColorOrange500,
        600: c.ColorOrange600,
        700: c.ColorOrange700,
        800: c.ColorOrange800,
    },
    blue: {
        100: c.ColorBlue100,
        200: c.ColorBlue200,
        300: c.ColorBlue300,
        400: c.ColorBlue400,
        500: c.ColorBlue500,
        600: c.ColorBlue600,
        700: c.ColorBlue700,
        800: c.ColorBlue800,
    },
    blue_secondary: {
        100: c.ColorBlueSecondary100,
        200: c.ColorBlueSecondary200,
        300: c.ColorBlueSecondary300,
        400: c.ColorBlueSecondary400,
        500: c.ColorBlueSecondary500,
        600: c.ColorBlueSecondary600,
        700: c.ColorBlueSecondary700,
        800: c.ColorBlueSecondary800,
    },
    green: {
        100: c.ColorGreen100,
        200: c.ColorGreen200,
        300: c.ColorGreen300,
        400: c.ColorGreen400,
        500: c.ColorGreen500,
        600: c.ColorGreen600,
        700: c.ColorGreen700,
        800: c.ColorGreen800,
    },
    yellow: {
        100: c.ColorYellow100,
        200: c.ColorYellow200,
        300: c.ColorYellow300,
        400: c.ColorYellow400,
        500: c.ColorYellow500,
        600: c.ColorYellow600,
        700: c.ColorYellow700,
        800: c.ColorYellow800,
    },
    red: {
        100: c.ColorRed100,
        200: c.ColorRed200,
        300: c.ColorRed300,
        400: c.ColorRed400,
        500: c.ColorRed500,
        600: c.ColorRed600,
        700: c.ColorRed700,
        800: c.ColorRed800,
    },
    purple: {
        100: c.ColorPurple100,
        200: c.ColorPurple200,
        300: c.ColorPurple300,
        400: c.ColorPurple400,
        500: c.ColorPurple500,
        600: c.ColorPurple600,
        700: c.ColorPurple700,
        800: c.ColorPurple800,
    },
    light_blue: {
        100: c.ColorLightBlue100,
        200: c.ColorLightBlue200,
        300: c.ColorLightBlue300,
        400: c.ColorLightBlue400,
        500: c.ColorLightBlue500,
        600: c.ColorLightBlue600,
        700: c.ColorLightBlue700,
        800: c.ColorLightBlue800,
    },
    ink: {
        100: c.ColorInk100,
        150: c.ColorInk150,
        300: c.ColorInk300,
        400: c.ColorInk400,
        450: c.ColorInk450,
        550: c.ColorInk550,
        600: c.ColorInk600,
        650: c.ColorInk650,
        700: c.ColorInk700,
    },
    text: {
        primary: c.ColorForegroundLight,
        secondary: c.ColorForegroundDeEmpLight,
        disabled: c.ColorForegroundDisableLight
    },
    divider: c.ColorBorderLight,
    common: {
        black: c.ColorBlack,
        white: c.ColorWhite,
    },
    icon: c.ColorIconDefaultLight,
    background: {
        default: c.ColorBackgroundLight,
        paper: c.ColorBackgroundLight,
    },
};
export const darkPalette = {
    type: "dark",
    semantic: {
        colorBackground: c.ColorBackgroundDark,
        colorBackgroundSecondary: c.ColorBackgroundSecondaryDark,
        colorBackgroundInverse: c.ColorBackgroundInverseDark,
        colorBackgroundGray: c.ColorBackgroundGrayDark,
        colorBackgroundDisabled: c.ColorBackgroundDisabledDark,
        colorBackgroundHighlight: c.ColorBackgroundHighlightDark,
        colorBackgroundRaised: c.ColorBackgroundRaisedDark,
        colorBackgroundEdit: c.ColorBackgroundEditDark,
        colorBackgroundGrayEmp: c.ColorBackgroundGrayEmpDark,
        colorHover: c.ColorHoverDark,
        colorCurtain: c.ColorCurtainDark,
        colorBorder: c.ColorBorderDark,
        colorBorderDisabled: c.ColorBorderDisabledDark,
        colorBorderGrid: c.ColorBorderGridDark,
        colorBorderDeEmp: c.ColorBorderDeEmpDark,
        colorSelection: c.ColorSelectionDark,
        colorLogo: c.ColorLogoDark,
        colorForeground: c.ColorForegroundDark,
        colorForegroundLight: c.ColorForegroundLightDark,
        colorForegroundEmp: c.ColorForegroundEmpDark,
        colorForegroundDeEmp: c.ColorForegroundDeEmpDark,
        colorForegroundDisable: c.ColorForegroundDisableDark,
        colorForegroundInverse: c.ColorForegroundInverseDark,
        colorForegroundHighlight: c.ColorForegroundHighlightDark,
        colorForegroundHighlightSelected: c.ColorForegroundHighlightSelectedDark,
        colorForegroundHighlightSelectedHover: c.ColorForegroundHighlightSelectedHoverDark,
        colorForegroundLink: c.ColorForegroundLinkDark,
        colorForegroundLinkPressed: c.ColorForegroundLinkPressedDark,
        colorForegroundInvDeEmp: c.ColorForegroundInvDeEmpDark,
        colorPrimary: c.ColorPrimaryDark,
        colorPrimaryLighter: c.ColorPrimaryLighterDark,
        colorPrimaryDarker: c.ColorPrimaryDarkerDark,
        colorPrimaryHover: c.ColorPrimaryHoverDark,
        colorPrimaryFocused: c.ColorPrimaryFocusedDark,
        colorPrimaryPressed: c.ColorPrimaryPressedDark,
        colorSecondaryFocused: c.ColorSecondaryFocusedDark,
        colorSecondaryPressed: c.ColorSecondaryPressedDark,
        colorChipDefaultBackground: c.ColorChipDefaultBackgroundDark,
        colorChipErrorBackground: c.ColorChipErrorBackgroundDark,
        colorChipWarningBackground: c.ColorChipWarningBackgroundDark,
        colorChipInfoBackground: c.ColorChipInfoBackgroundDark,
        colorChipSuccessBackground: c.ColorChipSuccessBackgroundDark,
        colorErrorIcon: c.ColorErrorIconDark,
        colorErrorText: c.ColorErrorTextDark,
        colorErrorBackground: c.ColorErrorBackgroundDark,
        colorErrorForegroundInverse: c.ColorErrorForegroundInverseDark,
        colorInfoForeground: c.ColorInfoForegroundDark,
        colorInfoIcon: c.ColorInfoIconDark,
        colorInfoText: c.ColorInfoTextDark,
        colorInfoForegroundInverse: c.ColorInfoForegroundInverseDark,
        colorInfoBackground: c.ColorInfoBackgroundDark,
        colorSuccessIcon: c.ColorSuccessIconDark,
        colorSuccessText: c.ColorSuccessTextDark,
        colorSuccessBackground: c.ColorSuccessBackgroundDark,
        colorSuccessForegroundInverse: c.ColorSuccessForegroundInverseDark,
        colorWarningIcon: c.ColorWarningIconDark,
        colorWarningText: c.ColorWarningTextDark,
        colorWarningBackground: c.ColorWarningBackgroundDark,
        colorWarningForegroundInverse: c.ColorWarningForegroundInverseDark,
        colorIconDefault: c.ColorIconDefaultDark,
        colorIconInvertedDefault: c.ColorIconInvertedDefaultDark,
        colorToggleOffHover: c.ColorToggleOffHoverDark,
        colorToggleOffFocus: c.ColorToggleOffFocusDark,
        colorToggleOffPressed: c.ColorToggleOffPressedDark,
        colorToggleOnHover: c.ColorToggleOnHoverDark,
        colorToggleOnFocus: c.ColorToggleOnFocusDark,
        colorToggleOnPressed: c.ColorToggleOnPressedDark,
        colorCalloutBackground: c.ColorCalloutBackgroundDark,
        colorWarn: c.ColorWarnDark,
        colorWarnDarker: c.ColorWarnDarkerDark,
        colorWarnHover: c.ColorWarnHoverDark,
        colorWarnFocus: c.ColorWarnFocusDark,
        colorWarnPressed: c.ColorWarnPressedDark,
        colorCarouselBackground: c.ColorCarouselBackgroundDark,
        colorIconButtonHover: c.ColorIconButtonHoverDark,
        colorIconButtonFocus: c.ColorIconButtonFocusDark,
        colorIconButtonPressed: c.ColorIconButtonPressedDark,
        colorCodeFunction: c.ColorCodeFunctionDark,
        colorCodeOperator: c.ColorCodeOperatorDark,
        colorCodeNumeric: c.ColorCodeNumericDark,
        colorCodeText: c.ColorCodeTextDark,
        colorToggleThumbOff: c.ColorToggleThumbOffDark,
        colorToggleTrackOff: c.ColorToggleTrackOffDark,
        colorToggleThumbOn: c.ColorToggleThumbOnDark,
        colorToggleTrackOn: c.ColorToggleTrackOnDark,
        colorToggleThumbOffDisabled: c.ColorToggleThumbOffDisabledDark,
        colorToggleTrackOffDisabled: c.ColorToggleTrackOffDisabledDark,
        colorToggleThumbOnDisabled: c.ColorToggleThumbOnDisabledDark,
        colorToggleTrackOnDisabled: c.ColorToggleTrackOnDisabledDark,
        // Keep these typos for compatibility reasons
        colorBackgroundHigh: c.ColorBackgroundHighlightDark,
        colorForegroundHigh: c.ColorForegroundHighlightDark,
        colorForegroundHighSelected: c.ColorForegroundHighlightSelectedDark,
        colorForegroundHighSelectedHover: c.ColorForegroundHighlightSelectedHoverDark,
    },
    primary: {
        contrastText: c.ColorWhite,
        light: c.ColorPrimaryLighterLight,
        main: c.ColorPrimaryDark,
        dark: c.ColorPrimaryLighterDark,
    },
    secondary: {
        contrastText: c.ColorWhite,
        light: c.ColorPrimaryLighterLight,
        main: c.ColorPrimaryDark,
        dark: c.ColorPrimaryLighterDark,
    },
    error: {
        contrastText: c.ColorWhite,
        light: c.ColorError250,
        main: c.ColorError500,
        dark: c.ColorError750,
    },
    success: {
        contrastText: c.ColorWhite,
        light: c.ColorGreen250,
        main: c.ColorGreen500,
        dark: c.ColorGreen750,
    },
    warning: {
        contrastText: c.ColorWhite,
        light: c.ColorWarning300,
        main: c.ColorWarning500,
        dark: c.ColorWarning700,
    },
    info: {
        contrastText: c.ColorBlack,
        light: c.ColorInfoBackgroundDark,
        main: c.ColorInfoForegroundDark,
        dark: c.ColorInfo700,
    },
    orange: {
        100: c.ColorOrange100,
        200: c.ColorOrange200,
        300: c.ColorOrange300,
        400: c.ColorOrange400,
        500: c.ColorOrange500,
        600: c.ColorOrange600,
        700: c.ColorOrange700,
        800: c.ColorOrange800,
    },
    blue: {
        100: c.ColorBlue100,
        200: c.ColorBlue200,
        300: c.ColorBlue300,
        400: c.ColorBlue400,
        500: c.ColorBlue500,
        600: c.ColorBlue600,
        700: c.ColorBlue700,
        800: c.ColorBlue800,
    },
    blue_secondary: {
        100: c.ColorBlueSecondary100,
        200: c.ColorBlueSecondary200,
        300: c.ColorBlueSecondary300,
        400: c.ColorBlueSecondary400,
        500: c.ColorBlueSecondary500,
        600: c.ColorBlueSecondary600,
        700: c.ColorBlueSecondary700,
        800: c.ColorBlueSecondary800,
    },
    green: {
        100: c.ColorGreen100,
        200: c.ColorGreen200,
        300: c.ColorGreen300,
        400: c.ColorGreen400,
        500: c.ColorGreen500,
        600: c.ColorGreen600,
        700: c.ColorGreen700,
        800: c.ColorGreen800,
    },
    yellow: {
        100: c.ColorYellow100,
        200: c.ColorYellow200,
        300: c.ColorYellow300,
        400: c.ColorYellow400,
        500: c.ColorYellow500,
        600: c.ColorYellow600,
        700: c.ColorYellow700,
        800: c.ColorYellow800,
    },
    red: {
        100: c.ColorRed100,
        200: c.ColorRed200,
        300: c.ColorRed300,
        400: c.ColorRed400,
        500: c.ColorRed500,
        600: c.ColorRed600,
        700: c.ColorRed700,
        800: c.ColorRed800,
    },
    purple: {
        100: c.ColorPurple100,
        200: c.ColorPurple200,
        300: c.ColorPurple300,
        400: c.ColorPurple400,
        500: c.ColorPurple500,
        600: c.ColorPurple600,
        700: c.ColorPurple700,
        800: c.ColorPurple800,
    },
    light_blue: {
        100: c.ColorLightBlue100,
        200: c.ColorLightBlue200,
        300: c.ColorLightBlue300,
        400: c.ColorLightBlue400,
        500: c.ColorLightBlue500,
        600: c.ColorLightBlue600,
        700: c.ColorLightBlue700,
        800: c.ColorLightBlue800,
    },
    ink: {
        100: c.ColorInk100,
        150: c.ColorInk150,
        300: c.ColorInk300,
        400: c.ColorInk400,
        450: c.ColorInk450,
        550: c.ColorInk550,
        600: c.ColorInk600,
        650: c.ColorInk650,
        700: c.ColorInk700,
    },
    text: {
        primary: c.ColorForegroundDark,
        secondary: c.ColorForegroundDeEmpDark,
        disabled: c.ColorForegroundDisableDark
    },
    divider: c.ColorBorderDark,
    common: {
        black: c.ColorBlack,
        white: c.ColorWhite,
    },
    icon: c.ColorIconDefaultDark,
    background: {
        default: c.ColorBackgroundDark,
        paper: c.ColorBackgroundDark,
    },
};
